import ApiClient from 'api/ApiClient'

class RoofPitchesApi extends ApiClient {
  constructor() {
    super({url:'roof_pitches'})
  }
}

export default RoofPitchesApi
